<template>
  <div>
    <div class="mb-2px mr-2">
      <BaseOrangeText class="font-heavy">
        <template v-if="total > current">
          {{ total - current | currency }} {{ $t('of remaining wishes') }}
        </template>
        <template v-else>
          {{ current | currency }} {{ $t('of expressed wishes') }}
        </template>
      </BaseOrangeText>
    </div>
    <BaseGreyText>
      {{ $t('of the') }} {{ total | currency }} {{ $t('proposed') }}
      <template v-if="overSubscription > 0">
        ({{ goal | currency }} + {{ overSubscription }}%)
      </template>
    </BaseGreyText>
  </div>
</template>

<script>
import BaseOrangeText from './BaseOrangeText.vue';
import BaseGreyText from './BaseGreyText.vue';

export default {
  name: 'BaseProgressBarHeader',
  components: {
    BaseOrangeText,
    BaseGreyText,
  },
  props: {
    current: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    goal: {
      type: Number,
      required: true,
    },
    overSubscription: {
      type: Number,
      required: true,
    },
  },
};
</script>
